var _g, _g2, _g3, _g4, _g5, _g6, _g7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFewCloudsNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 161 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_303_725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.6904 53.3063C73.9196 62.4993 72.7455 75.0453 78.7183 85.3905C84.6912 95.7358 96.1433 100.992 107.49 99.7247C105.077 103 101.954 105.85 98.1904 108.023C83.8641 116.295 65.6831 111.625 57.5819 97.5936C49.4808 83.5621 54.5274 65.482 68.8537 57.2107C72.6174 55.0377 76.6472 53.7579 80.6904 53.3063Z",
    fill: "#FFEE94"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_303_725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.224 60.0913C105.345 59.4018 105.409 58.6926 105.409 57.9687C105.409 51.1966 99.8675 45.7068 93.0324 45.7068C87.951 45.7068 83.5848 48.7408 81.6788 53.0802C80.1347 51.7594 78.131 50.9619 75.9414 50.9619C71.0592 50.9619 67.1013 54.9268 67.1013 59.8177C67.1013 60.09 67.1136 60.3595 67.1376 60.6256C64.7893 61.7652 63.1724 64.1564 63.1724 66.9218C63.1724 70.7915 66.3387 73.9286 70.2445 73.9286H103.641C107.546 73.9286 110.713 70.7915 110.713 66.9218C110.713 63.5913 108.367 60.8036 105.224 60.0913Z",
    fill: "url(#paint0_linear_303_725)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_303_725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0593 57.1804C73.8787 65.5721 72.807 77.0244 78.2591 86.4679C83.7113 95.9114 94.1652 100.709 104.523 99.5526C102.321 102.543 99.4696 105.144 96.0339 107.128C82.9564 114.678 66.3601 110.416 58.9652 97.6073C51.5702 84.7988 56.1768 68.2948 69.2544 60.7445C72.69 58.7609 76.3686 57.5926 80.0593 57.1804Z",
    fill: "url(#paint1_linear_303_725)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_303_725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.0514 102.499C76.1729 101.81 76.2362 101.101 76.2362 100.377C76.2362 93.6048 70.6952 88.115 63.86 88.115C58.7786 88.115 54.4125 91.149 52.5065 95.4884C50.9623 94.1676 48.9587 93.3701 46.7691 93.3701C41.8868 93.3701 37.9289 97.335 37.9289 102.226C37.9289 102.498 37.9412 102.768 37.9652 103.034C35.617 104.173 34 106.565 34 109.33C34 113.2 37.1663 116.337 41.0721 116.337H74.4681C78.374 116.337 81.5402 113.2 81.5402 109.33C81.5402 106 79.195 103.212 76.0514 102.499Z",
    fill: "url(#paint2_linear_303_725)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_303_725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7066 57.9653C54.8661 59.2267 53.7574 60.2927 52.7413 62.9307C51.932 60.3742 50.9369 59.2338 47.7759 57.9653C51.0276 56.9059 51.9101 55.6795 52.7413 53C53.7626 55.4696 54.3935 56.8173 57.7066 57.9653Z",
    fill: "url(#paint3_linear_303_725)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_di_303_725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.356 85.2468C100.515 86.5082 99.4067 87.5742 98.3906 90.2122C97.5813 87.6557 96.5862 86.5153 93.4252 85.2468C96.6769 84.1874 97.5594 82.961 98.3906 80.2815C99.4119 82.751 100.043 84.0988 103.356 85.2468Z",
    fill: "url(#paint4_linear_303_725)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_di_303_725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4216 64.9609C44.2999 65.459 43.8621 65.88 43.4609 66.9217C43.1413 65.9122 42.7483 65.4619 41.5001 64.9609C42.7842 64.5426 43.1326 64.0583 43.4609 63.0002C43.8642 63.9754 44.1133 64.5076 45.4216 64.9609Z",
    fill: "url(#paint5_linear_303_725)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_303_725",
    x: 0.716675,
    y: 0.306396,
    width: 159.773,
    height: 164.807,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.5,
    result: "effect1_foregroundBlur_303_725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_303_725",
    x: 63.1724,
    y: 45.7068,
    width: 47.5402,
    height: 38.2217,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_303_725",
    x: 55.4368,
    y: 57.1804,
    width: 49.0862,
    height: 57.6814,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_303_725",
    x: 34,
    y: 88.115,
    width: 47.5402,
    height: 38.2217,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_303_725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_303_725",
    x: 39.0085,
    y: 50.2326,
    width: 27.4656,
    height: 27.4656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.38372
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.278813 0 0 0 0 0.232917 0 0 0 0 0.5375 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_303_725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_303_725",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_303_725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_di_303_725",
    x: 84.6578,
    y: 77.514,
    width: 27.4656,
    height: 27.4656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.38372
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.278813 0 0 0 0 0.232917 0 0 0 0 0.5375 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_303_725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_303_725",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_303_725"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_di_303_725",
    x: 32.7327,
    y: 60.2328,
    width: 21.4564,
    height: 21.4563,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.38372
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.278813 0 0 0 0 0.232917 0 0 0 0 0.5375 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_303_725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_303_725",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_303_725"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_303_725",
    x1: 66.1961,
    y1: 71.4088,
    x2: 114.156,
    y2: 35.5436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_303_725",
    x1: 81.4052,
    y1: 52.7301,
    x2: 71.5932,
    y2: 112.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_303_725",
    x1: 37.0237,
    y1: 113.817,
    x2: 84.984,
    y2: 77.9518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_303_725",
    x1: 51.3048,
    y1: 63.396,
    x2: 55.9782,
    y2: 54.6214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_303_725",
    x1: 96.9541,
    y1: 90.6774,
    x2: 101.628,
    y2: 81.9029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_303_725",
    x1: 42.8936,
    y1: 67.1054,
    x2: 44.7391,
    y2: 63.6404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE94"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFewCloudsNight);
export default __webpack_public_path__ + "static/media/Few-Clouds_Night.54d146b3a94f46c263f1e61289bbf8bb.svg";
export { ForwardRef as ReactComponent };